import React from 'react';

import { useSelector } from 'react-redux';

import FormSection from 'components/Layouts/Form/FormSection';
import {
  PAGE_TYPE_ABOUT_SAFARI,
  PAGE_TYPE_ABOUT_US,
  PAGE_TYPE_ACTIVITY,
  PAGE_TYPE_AREA,
  PAGE_TYPE_HELP_ARTICLE,
  PAGE_TYPE_MISC,
  PAGE_TYPE_PRE_TRAVEL_INFO,
  PAGE_TYPE_PROPERTY,
  PAGE_TYPE_HELP_TUTORIAL,
} from 'constants/index';
import { pageDataSelector } from 'store/page/selectors';

import AboutUs from '../../PageTypes/AboutUs/Details';
import Activity from '../../PageTypes/Activity/Details';
import Area from '../../PageTypes/Area/Details';
import HelpArticle from '../../PageTypes/HelpArticle/Details';
import HelpTutorial from '../../PageTypes/HelpTutorial/Details';
import Miscellaneous from '../../PageTypes/Miscellaneous/Details';
import NoteAboutSafari from '../../PageTypes/NoteAboutSafari/Details';
import PreTravelInformation from '../../PageTypes/PreTravelInformation/Details';
import Property from '../../PageTypes/Property/Details';

const pageTypeComponentsMap = {
  [PAGE_TYPE_AREA]: Area,
  [PAGE_TYPE_PROPERTY]: Property,
  [PAGE_TYPE_ACTIVITY]: Activity,
  [PAGE_TYPE_MISC]: Miscellaneous,
  [PAGE_TYPE_ABOUT_SAFARI]: NoteAboutSafari,
  [PAGE_TYPE_ABOUT_US]: AboutUs,
  [PAGE_TYPE_PRE_TRAVEL_INFO]: PreTravelInformation,
  [PAGE_TYPE_HELP_ARTICLE]: HelpArticle,
  [PAGE_TYPE_HELP_TUTORIAL]: HelpTutorial,
};

function Details() {
  const page = useSelector(pageDataSelector);
  const PageTypeComponent = pageTypeComponentsMap[page.type];

  return PageTypeComponent ? (
    <FormSection>
      <PageTypeComponent />
    </FormSection>
  ) : null;
}

export default Details;
